<syn-avatar
    matIco="web"
    [text]="language?.displayName"
    [backgroundColor]="backgroundColor"
    [iconColor]="iconColor"
    [muted]="muted"
></syn-avatar>
